import VMasker from "vanilla-masker";

export const maskCNPJHelper = (value) => {
  const mask = VMasker.toPattern(value, "99.999.999/9999-99");

  return mask;
};
